module.exports = __webpack_public_path__ + "static/media/step_1.c018c192.png";